/***********************************************************
Alexander Self
8/22/17
Gang Reducer: Manages and creation and editing of gangs
***********************************************************/
import { ADD_GANG_MEMBER, REMOVE_GANG_MEMBER, GANG_AUTOCOMPLETE, FETCH_TIMESHEET_DATA,
  CREATE_GANG, FETCH_GANGS, SELECT_GANG, SELECT_GANG_TO_EDIT, ADD_GANG_MEMBER_TO_EDIT,
  REMOVE_GANG_MEMBER_FROM_EDIT, EDIT_GANG, GANG_EDIT_AUTOCOMPLETE, SUBMIT_GANG_TIMESHEET,
  SUBMIT_REG_TIMESHEET, DELETE_GANG } from '../actions/types';
const Materialize = window.Materialize;
const initState = {
  gangs: [],
  employees: [],
  selectedGang: {
    emps: []
  },
  create: {
    gangMembers: [], // All employees to be added to the gang
    count: 0
  },
  edit: {
    selectedGang: {
      emps: [],
      gangCount: 0
    },
    addedMembers: [],
    removedMembers: []
  }
};

export default function GangReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_TIMESHEET_DATA:
      //console.log(action.payload);
      let _gangs = state.gangs;
      let _employees = action.payload.employees;
      /* If a employee already belongs to a gang; remove them from the employee list */
      for (const gang of _gangs) {
        let gangMembers = gang.emps;
        for (const member of gangMembers) {
          _employees = _employees.filter((e) => e.eid !== member.eid);
        }
      }
      return { ...state,
        employees: _employees.sort(sortById)
      };
    case ADD_GANG_MEMBER:
      /* Check if member exists in current build */
      if ( state.create.gangMembers.find((e) => e.eid === action.payload.eid) ) return state;
      /* Check if member is duplcate and exists in any gang */
      for (let { emps } of state.gangs) if (emps.find((e) => e.eid === action.payload.eid)) return state;

      return { ...state,
        create: {
          ...state.create,
          gangMembers: state.create.gangMembers.concat(action.payload),
          count: state.create.count + 1
        }
      };
    case REMOVE_GANG_MEMBER:
      return { ...state,
        create: {
          ...state.create,
          gangMembers: state.create.gangMembers.filter((e) => e.eid !== action.payload.eid),
          count: state.create.count - 1
        }
      };
    case GANG_AUTOCOMPLETE:
      // Make sure not in list
      if ( state.create.gangMembers.find((e) => e.eid === action.payload.eid) ) return state;

      return { ...state,
        create: {
          ...state.create,
          gangMembers: state.create.gangMembers.concat(action.payload),
          count: state.create.count + 1
        }
      };
      //return state;
    case GANG_EDIT_AUTOCOMPLETE:
      /* Check if a gang has been selected: Don't do this in reducer again */
      if (!state.edit.selectedGang.id) {
        Materialize.toast('Please select a gang before adding an employee', 4000, 'red rounded');
        return state;
      }

      if (state.edit.selectedGang.emps.find((e) => e.eid === action.payload.eid)) return state;

      let _emps_ = state.edit.selectedGang.emps.concat(action.payload);
      return { ...state,
        edit: {
          ...state.eid,
          selectedGang: {
            ...state.edit.selectedGang,
            gangCount: state.edit.selectedGang.gangCount + 1,
            emps: _emps_
          },// Clean up lists after adding members
          addedMembers: state.edit.addedMembers.concat(action.payload),
          removedMembers: state.edit.removedMembers.filter((e) => e.eid !== action.payload.eid)
        }
      };
    case CREATE_GANG:
      let newEmployeeList;
      newEmployeeList = state.employees.map((emp) => {
        if (action.selectedEmps.find((e) => e.eid === emp.eid)) return 1
        else return emp;
      });


      return { ...state,
        gangs: action.payload,
        employees: newEmployeeList.filter((e) => e !== 1).sort(sortById),
        create: {
          gangMembers: []
        }
      };
    case FETCH_GANGS:
      let gangs = action.payload;
      let employees = state.employees;
      /* If a employee already belongs to a gang; remove them from the employee list */
      for (const gang of gangs) {
        let gangMembers = gang.emps;
        for (const member of gangMembers) {
          employees = employees.filter((e) => e.eid !== member.eid);
        }
      }
      return { ...state,
        employees,
        gangs: action.payload
      };
    case SELECT_GANG:
      let gang = state.gangs.find((g) => g.gangId === action.payload);
      return { ...state,
        selectedGang: gang
      };
    case SELECT_GANG_TO_EDIT:
      let gangToEdit = state.gangs.find((g) => g.gangId === action.payload);
      let __gangs = state.gangs;
      let __employees = state.employees;
      /* If a employee already belongs to a gang; remove them from the employee list */
      for (const gang of __gangs) {
        let gangMembers = gang.emps;
        for (const member of gangMembers) {
          __employees = __employees.filter((e) => e.eid !== member.eid);
        }
      }
      return { ...state,
        employees: __employees,
        edit: {
          ...state.edit,
          selectedGang: gangToEdit
        }
      };
    case REMOVE_GANG_MEMBER_FROM_EDIT:
      /* Maintain a list of employees who were removed and added during edit;
        also if removed, repopulate that employee into main employees list
       */
       let _emps = state.edit.selectedGang.emps.filter((e) => e.eid !== action.payload.eid);
      return { ...state,
        employees: state.employees.concat(action.payload).sort(sortById),
        edit: {
          ...state.edit,
          selectedGang: {
            ...state.edit.selectedGang,
            gangCount: state.edit.selectedGang.gangCount - 1,
            emps: _emps
          },
          removedMembers: state.edit.removedMembers.concat(action.payload),
          addedMembers: state.edit.addedMembers.filter((e) => e.eid !== action.payload.eid)
        }
      };
    case ADD_GANG_MEMBER_TO_EDIT:
      if ( state.edit.selectedGang.emps.find((e) => e.eid === action.payload.eid) ) return state;
      let emps = state.edit.selectedGang.emps.concat(action.payload);
      return { ...state,
        employees: state.employees.filter((e) => e.eid !== action.payload.eid),
        edit: {
          ...state.edit,
          selectedGang: {
            ...state.edit.selectedGang,
            gangCount: state.edit.selectedGang.gangCount + 1,
            emps
          },// Clean up lists after adding members
          addedMembers: state.edit.addedMembers.concat(action.payload),
          removedMembers: state.edit.removedMembers.filter((e) => e.eid !== action.payload.eid)
        }
      };
    case EDIT_GANG:
      return { ...state,
        gangs: action.payload,
        edit: {
          selectedGang: {
            emps: []
          },
          addedMembers: [],
          removedMembers: []
        }
      };
    case DELETE_GANG:
      for (let e of action.oldGang.emps) {
        state.employees.push(e);
      }
      return {
        gangs: action.payload,
        employees: state.employees.sort(sortById),
        selectedGang: {
          emps: []
        },
        create: {
          gangMembers: [], // All employees to be added to the gang
          count: 0
        },
        edit: {
          selectedGang: {
            emps: [],
            gangCount: 0
          },
          addedMembers: [],
          removedMembers: []
        }
      };
    case SUBMIT_GANG_TIMESHEET:
      return { ...state,
        gangs: action.gangs
      };
    case SUBMIT_REG_TIMESHEET:
      return { ...state,
        gangs: action.gangs
      };
    default:
      return state;
  }
}


function sortById(a,b) {
  return a.id - b.id;
}

/* END */



// WEBPACK FOOTER //
// ./src/reducers/gang_reducer.js